import { paymentSubscriptionService } from "@/features/protest/services";
type ProceedToPaymentParams = {
  amount: number;
  useWallet: boolean;
  userId: string | number;
  propertyId: string;
  year?: number;
  /** Promo code applied on the client, or "" */
  couponCode?: string;
};

export const handleProceedToPayment = async ({
  amount,
  useWallet,
  userId,
  propertyId,
  year = 2026,
  couponCode = "",
}: ProceedToPaymentParams) => {
  const intentResponse = await paymentSubscriptionService.createPaymentIntent({
    user_id: userId,
    property_id: propertyId,
    year,
    amount,
    currency: "usd",
    use_wallet: useWallet,
    coupon_code: couponCode.trim(),
  });

  const payload = intentResponse.data;
  const paymentData = payload?.data;
  const clientSecret = paymentData?.client_secret || payload?.client_secret;

  if (!clientSecret) {
    throw new Error(
      payload?.message || intentResponse.message || "Failed to create payment intent"
    );
  }

  return paymentData || payload;
};
